/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    max-width: 100%;
    padding-top: 24px;
  `}
`;

export const FormLine = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    max-width: 100%;
    width: 100%;
  `}
`;

export const NacionalityWrapper = styled.div`
  ${({ theme }) => css`
    flex: 1 1 30%;
    display: flex;
    min-width: 245px;
    > div {
      height: fit-content;
      width: 100%;
    }
    div {
      color: ${theme.v2.colors.neutral.lowMedium};
      font-size: ${theme.v2.font.sizes.xxs};
    }
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-width: 100%;
    }
  `}
`;

export const DocumentWrapper = styled.div`
  ${({ theme, $isForeigner }) => css`
    flex: ${$isForeigner ? '1 1 30%' : '1 1 50%'};
    display: flex;
    min-width: 245px;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-width: 100%;
    }
  `}
`;

export const BirthdayWrapper = styled.div`
  ${({ theme, $isForeigner }) => css`
    flex: ${$isForeigner ? '1 1 30%' : '1'};
    display: flex;
    min-width: 245px;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-width: 100%;
    }
  `}
`;

export const NameWrapper = styled.div`
  ${({ theme }) => css`
    flex: 1 1 50%;
    display: flex;
    min-width: 245px;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-width: 100%;
    }
  `}
`;

export const TelephoneWrapper = styled.div`
  ${({ theme }) => css`
    flex: 1;
    display: flex;
    min-width: 245px;
    input {
      color: ${theme.v2.colors.neutral.lowDark};
      font-size: ${theme.v2.font.sizes.xxs};
      font-family: ${theme.v2.font.family.primary};
    }
    label {
      color: ${theme.v2.colors.neutral.lowMedium};
      font-size: ${theme.v2.font.sizes.xxs};
      font-family: ${theme.v2.font.family.primary};
    }
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-width: 100%;
    }
  `}
`;

export const CountryWrapper = styled.div`
  ${({ theme }) => css`
    flex: 1 1 50%;
    display: inline-flex;
    min-width: 245px;
    div {
      color: ${theme.v2.colors.neutral.lowMedium};
      font-size: ${theme.v2.font.sizes.xxs};
    }
    > div {
      width: 100%;
      height: fit-content;
    }
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-width: 100%;
    }
  `}
`;

export const CepWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex: 1;
    gap: 20px;
    min-width: 420px;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: start;
      flex-direction: column;
      min-width: 100%;
    }
  `}
`;

export const DontKnowCepWrapper = styled.div`
  ${({ theme }) => css`
    align-self: start;
    min-width: 118px;
    margin-top: 16px;
    a {
      font-size: ${theme.v2.font.sizes.xxs};
    }
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin-top: 0px;
    }
  `}
`;

export const StateWrapper = styled.div`
  ${({ theme }) => css`
    flex: 1;
    display: flex;
    min-width: 271px;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-width: 100%;
    }
  `}
`;

export const CityWrapper = styled.div`
  ${({ theme }) => css`
    flex: 1 1 50%;
    display: inline-flex;
    min-width: 245px;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-width: 100%;
    }
  `}
`;

export const AddressWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
  `}
`;

export const BlockWrapper = styled.div`
  ${({ theme }) => css`
    flex: 1;
    display: flex;
    min-width: 309px;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-width: 100%;
    }
  `}
`;

export const ComplementWrapper = styled.div`
  ${({ theme }) => css`
    flex: 1 1 50%;
    display: flex;
    min-width: 245px;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-width: 100%;
    }
  `}
`;

export const CheckboxInputAdapter = styled.button`
${({ theme }) => css`
    background: transparent;
    border: 0px;
  `}
`;

export const CheckboxInput = styled.input`
  display: none;
`;

export const Checkbox = styled.div`
  ${({ theme, checked }) => css`
    background-color: ${checked ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.white.primary};
    border: 2px solid ${checked ? 'transparent' : theme.v2.colors.neutral.lowLight};
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    height: 19px;
    transition: all 300ms;
    width: 19px;

    svg {
      flex: 0 0 15px;
    };

    &:hover {
      ${!checked && css`
        border: 2px solid ${theme.v2.colors.neutral.lowDark};
      `};
    };
  `}
`;

export const CheckboxLabel = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `}
`;

export const CheckboxWrapper = styled.div`
  ${({ theme, $disabled }) => css`
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    gap: 4px;
    padding-bottom: 6px;

    ${$disabled && css`
      cursor: not-allowed;
      pointer-events: none;
      ${CheckboxLabel} {
        color: ${theme.v2.colors.neutral.lowLight};   
      }
      ${Checkbox} {
        background-color: ${theme.v2.colors.neutral.highLight};
        border-color:${theme.v2.colors.neutral.highMedium};
      }
    `}
  `}
`;

export const AddressComplementsWrapper = styled.div`
  ${({ theme, $renderAddressFields }) => css`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px;
    width: 100%;
    overflow: hidden;
    max-height: ${$renderAddressFields ? '1000px' : '0'};
    transition: max-height 0.2s ease-in-out;
  `}
`;

export const LoadingWrapper = styled.div`
  ${({ theme }) => css`
    margin: 0 auto;
  `}
`;
